export const generatedSmallBodySourceCandidateLedger = {
  "schemaVersion": 1,
  "generatedAt": "2026-06-22T00:00:00.000Z",
  "mode": "deterministic-small-body-source-candidate-ledger",
  "operatingRule": "CAD/SBDB candidate evidence may rank logistics geometry, but resource composition remains blocked until taxonomy, spectra, or mission/archive evidence is attached.",
  "sourceMeta": {
    "sourceIds": [
      "cad-api",
      "sbdb-api",
      "mpc",
      "pds"
    ],
    "primarySource": "NASA/JPL CNEOS CAD API",
    "supportingSources": [
      "NASA/JPL SBDB API for object identity, orbit solution, and physical fields.",
      "IAU Minor Planet Center for observation/designation bridge.",
      "NASA PDS Small Bodies Node for spectra, taxonomy, and mission/archive resource evidence."
    ],
    "query": "cad.api?dist-max=0.05&date-min=2026-01-01&date-max=2026-12-31&diameter=true&sort=dist",
    "inputPath": "evidence/source-candidate-payloads/small-body-live-capture-current.json",
    "captureTimestamp": "2026-06-22T00:00:00.000Z",
    "liveCapture": true,
    "captureArtifact": {
      "mode": "small-body-live-source-capture-review-artifact",
      "artifactHash": "sha256-2ad162480cc48a0874105a289f1df9732e325c92f043f7f9d1ba379bb8f37d98",
      "captureState": "pending-review",
      "cadRequest": {
        "url": "https://ssd-api.jpl.nasa.gov/cad.api?dist-max=0.05&date-min=2026-01-01&date-max=2026-12-31&diameter=true&sort=dist&limit=10",
        "status": 200,
        "ok": true,
        "responseHash": "sha256-044e42923e35cd4e3106269500076e464bbe84af8624cbc58dbc817eb7faa2fc",
        "fieldCount": 13,
        "rowCount": 10,
        "designations": [
          "2026 JN4",
          "2026 EM",
          "2026 HZ4",
          "2026 DN5",
          "2026 JM2",
          "2026 FS5",
          "2026 JV3",
          "2026 ET3",
          "2026 KU1",
          "2026 LX"
        ]
      },
      "sbdbRequestCount": 10,
      "sourceMetaHash": "sha256-2c67b934a7f28af9f9a43c735442f9b33761109a631cde1e7b819f1ea48f0c17"
    },
    "licenseOrTermsReview": "Official NASA/JPL public API data; verify downstream redistribution terms before commercial export.",
    "unitsMap": {
      "dist": "au",
      "dist_min": "au",
      "dist_max": "au",
      "v_rel": "km/s",
      "v_inf": "km/s",
      "diameter": "km",
      "diameter_sigma": "km",
      "h": "mag"
    },
    "uncertaintyMap": {
      "distance": "dist_min/dist_max range retained per approach row",
      "time": "t_sigma_f retained when provided",
      "resourceComposition": "unknown until taxonomy/spectra/mission archive evidence is attached"
    },
    "parserVersion": "small-body-candidate-evidence-v1",
    "reviewerApproval": "fixture-only-not-reviewable"
  },
  "payloadState": "live-capture-review-candidate",
  "promotionAllowed": false,
  "resourcePromotionAllowed": false,
  "geometryCandidateCount": 10,
  "sourceRowCount": 10,
  "fields": [
    "des",
    "orbit_id",
    "jd",
    "cd",
    "dist",
    "dist_min",
    "dist_max",
    "v_rel",
    "v_inf",
    "t_sigma_f",
    "h",
    "diameter",
    "diameter_sigma"
  ],
  "evidenceHashes": {
    "rawPayloadHash": "sha256-044e42923e35cd4e3106269500076e464bbe84af8624cbc58dbc817eb7faa2fc",
    "normalizedRecordHash": "sha256-6d060936f986102b7f1966d4c7b292dfdb2d8ebefe27569316051540e53f3857",
    "sourceMetaHash": "sha256-09996875d613717bf4b2a8e034b917dc1e5d26bba1759c07d4e2ea73256661c6"
  },
  "sourceCandidates": [
    {
      "id": "cad-2026 JM2",
      "designation": "2026 JM2",
      "name": "2026 JM2",
      "rowIndex": 4,
      "sourceIds": [
        "cad-api"
      ],
      "sourceRecordType": "cad-close-approach-record",
      "closeApproachDate": "2026-May-07 13:06",
      "orbitId": "3",
      "values": {
        "distanceAu": 0.000294100201228539,
        "distanceMinAu": 0.000293776751625198,
        "distanceMaxAu": 0.000294423602943003,
        "vRelativeKms": 5.82890597117675,
        "vInfinityKms": 3.98203598006233,
        "absoluteMagnitudeH": 32.69,
        "diameterKm": null,
        "diameterSigmaKm": null
      },
      "timeSigma": "< 00:01",
      "candidateInputs": {
        "closeApproachFrequency": 0.2,
        "vInfKms": 3.98203598006233,
        "diameterConfidence": 0.32,
        "orbitAccessibility": 0.856,
        "sourceUncertainty": 0.002,
        "resourceClassConfidence": 0.05
      },
      "geometryScore": 34.83,
      "resourcePromotionAllowed": false,
      "evidenceState": "geometry-screen-only",
      "blockers": [
        "CAD close-approach geometry does not identify asteroid composition.",
        "SBDB object record, MPC observation bridge, and taxonomy/spectra/mission evidence are still required."
      ],
      "closeApproachCount": 1,
      "bestCloseApproachDate": "2026-May-07 13:06",
      "approachRows": [
        {
          "rowIndex": 4,
          "closeApproachDate": "2026-May-07 13:06",
          "distanceAu": 0.000294100201228539,
          "distanceMinAu": 0.000293776751625198,
          "distanceMaxAu": 0.000294423602943003,
          "vRelativeKms": 5.82890597117675,
          "vInfinityKms": 3.98203598006233,
          "timeSigma": "< 00:01"
        }
      ],
      "promotionGate": {
        "geometryScreenAllowed": true,
        "resourcePromotionAllowed": false,
        "state": "blocked-for-resource-composition",
        "blockers": [
          "CAD close-approach geometry does not identify asteroid composition.",
          "SBDB object record, MPC observation bridge, and taxonomy/spectra/mission evidence are still required."
        ],
        "allowedUse": "May be used to prioritize follow-up source intake and trajectory screening. May not be used as a resource composition claim."
      },
      "candidateHash": "sha256-aaaca64ffad06f47149a8a993805f10145da065984eb52c522b5d98043e3cfc2"
    },
    {
      "id": "cad-2026 EM",
      "designation": "2026 EM",
      "name": "2026 EM",
      "rowIndex": 1,
      "sourceIds": [
        "cad-api"
      ],
      "sourceRecordType": "cad-close-approach-record",
      "closeApproachDate": "2026-Mar-07 19:45",
      "orbitId": "1",
      "values": {
        "distanceAu": 0.000185275976173685,
        "distanceMinAu": 0.000185184792086907,
        "distanceMaxAu": 0.000185367140441376,
        "vRelativeKms": 8.18617169785708,
        "vInfinityKms": 6.18474991688406,
        "absoluteMagnitudeH": 31.52,
        "diameterKm": null,
        "diameterSigmaKm": null
      },
      "timeSigma": "< 00:01",
      "candidateInputs": {
        "closeApproachFrequency": 0.2,
        "vInfKms": 6.18474991688406,
        "diameterConfidence": 0.32,
        "orbitAccessibility": 0.789,
        "sourceUncertainty": 0.001,
        "resourceClassConfidence": 0.05
      },
      "geometryScore": 24.44,
      "resourcePromotionAllowed": false,
      "evidenceState": "geometry-screen-only",
      "blockers": [
        "CAD close-approach geometry does not identify asteroid composition.",
        "SBDB object record, MPC observation bridge, and taxonomy/spectra/mission evidence are still required."
      ],
      "closeApproachCount": 1,
      "bestCloseApproachDate": "2026-Mar-07 19:45",
      "approachRows": [
        {
          "rowIndex": 1,
          "closeApproachDate": "2026-Mar-07 19:45",
          "distanceAu": 0.000185275976173685,
          "distanceMinAu": 0.000185184792086907,
          "distanceMaxAu": 0.000185367140441376,
          "vRelativeKms": 8.18617169785708,
          "vInfinityKms": 6.18474991688406,
          "timeSigma": "< 00:01"
        }
      ],
      "promotionGate": {
        "geometryScreenAllowed": true,
        "resourcePromotionAllowed": false,
        "state": "blocked-for-resource-composition",
        "blockers": [
          "CAD close-approach geometry does not identify asteroid composition.",
          "SBDB object record, MPC observation bridge, and taxonomy/spectra/mission evidence are still required."
        ],
        "allowedUse": "May be used to prioritize follow-up source intake and trajectory screening. May not be used as a resource composition claim."
      },
      "candidateHash": "sha256-4cc69d2d5b7a9f0819299bb3fadaf8fa6837b6390751faa8fd1ea8a309713ae3"
    },
    {
      "id": "cad-2026 LX",
      "designation": "2026 LX",
      "name": "2026 LX",
      "rowIndex": 9,
      "sourceIds": [
        "cad-api"
      ],
      "sourceRecordType": "cad-close-approach-record",
      "closeApproachDate": "2026-Jun-07 09:38",
      "orbitId": "7",
      "values": {
        "distanceAu": 0.000551340888395364,
        "distanceMinAu": 0.000551151367955083,
        "distanceMaxAu": 0.000551530398177911,
        "vRelativeKms": 8.07230947248158,
        "vInfinityKms": 7.44961264842787,
        "absoluteMagnitudeH": 28.853,
        "diameterKm": null,
        "diameterSigmaKm": null
      },
      "timeSigma": "< 00:01",
      "candidateInputs": {
        "closeApproachFrequency": 0.2,
        "vInfKms": 7.44961264842787,
        "diameterConfidence": 0.32,
        "orbitAccessibility": 0.75,
        "sourceUncertainty": 0.001,
        "resourceClassConfidence": 0.05
      },
      "geometryScore": 18.44,
      "resourcePromotionAllowed": false,
      "evidenceState": "geometry-screen-only",
      "blockers": [
        "CAD close-approach geometry does not identify asteroid composition.",
        "SBDB object record, MPC observation bridge, and taxonomy/spectra/mission evidence are still required."
      ],
      "closeApproachCount": 1,
      "bestCloseApproachDate": "2026-Jun-07 09:38",
      "approachRows": [
        {
          "rowIndex": 9,
          "closeApproachDate": "2026-Jun-07 09:38",
          "distanceAu": 0.000551340888395364,
          "distanceMinAu": 0.000551151367955083,
          "distanceMaxAu": 0.000551530398177911,
          "vRelativeKms": 8.07230947248158,
          "vInfinityKms": 7.44961264842787,
          "timeSigma": "< 00:01"
        }
      ],
      "promotionGate": {
        "geometryScreenAllowed": true,
        "resourcePromotionAllowed": false,
        "state": "blocked-for-resource-composition",
        "blockers": [
          "CAD close-approach geometry does not identify asteroid composition.",
          "SBDB object record, MPC observation bridge, and taxonomy/spectra/mission evidence are still required."
        ],
        "allowedUse": "May be used to prioritize follow-up source intake and trajectory screening. May not be used as a resource composition claim."
      },
      "candidateHash": "sha256-7d8d0bcec1b953ef32271ecb087c0e8c3308aa611abbfc45466ac5cc9dac775d"
    },
    {
      "id": "cad-2026 DN5",
      "designation": "2026 DN5",
      "name": "2026 DN5",
      "rowIndex": 3,
      "sourceIds": [
        "cad-api"
      ],
      "sourceRecordType": "cad-close-approach-record",
      "closeApproachDate": "2026-Feb-22 17:45",
      "orbitId": "4",
      "values": {
        "distanceAu": 0.000287726973376227,
        "distanceMinAu": 0.0002871949654878,
        "distanceMaxAu": 0.000288258436803427,
        "vRelativeKms": 8.60293606593264,
        "vInfinityKms": 7.44913567122022,
        "absoluteMagnitudeH": 30.91,
        "diameterKm": null,
        "diameterSigmaKm": null
      },
      "timeSigma": "00:01",
      "candidateInputs": {
        "closeApproachFrequency": 0.2,
        "vInfKms": 7.44913567122022,
        "diameterConfidence": 0.32,
        "orbitAccessibility": 0.75,
        "sourceUncertainty": 0.004,
        "resourceClassConfidence": 0.05
      },
      "geometryScore": 18.38,
      "resourcePromotionAllowed": false,
      "evidenceState": "geometry-screen-only",
      "blockers": [
        "CAD close-approach geometry does not identify asteroid composition.",
        "SBDB object record, MPC observation bridge, and taxonomy/spectra/mission evidence are still required."
      ],
      "closeApproachCount": 1,
      "bestCloseApproachDate": "2026-Feb-22 17:45",
      "approachRows": [
        {
          "rowIndex": 3,
          "closeApproachDate": "2026-Feb-22 17:45",
          "distanceAu": 0.000287726973376227,
          "distanceMinAu": 0.0002871949654878,
          "distanceMaxAu": 0.000288258436803427,
          "vRelativeKms": 8.60293606593264,
          "vInfinityKms": 7.44913567122022,
          "timeSigma": "00:01"
        }
      ],
      "promotionGate": {
        "geometryScreenAllowed": true,
        "resourcePromotionAllowed": false,
        "state": "blocked-for-resource-composition",
        "blockers": [
          "CAD close-approach geometry does not identify asteroid composition.",
          "SBDB object record, MPC observation bridge, and taxonomy/spectra/mission evidence are still required."
        ],
        "allowedUse": "May be used to prioritize follow-up source intake and trajectory screening. May not be used as a resource composition claim."
      },
      "candidateHash": "sha256-a25f00783f73361afb556cd6c49724c5d68b83b0135e59dd177ff6dde87c0f6a"
    },
    {
      "id": "cad-2026 KU1",
      "designation": "2026 KU1",
      "name": "2026 KU1",
      "rowIndex": 8,
      "sourceIds": [
        "cad-api"
      ],
      "sourceRecordType": "cad-close-approach-record",
      "closeApproachDate": "2026-May-22 22:11",
      "orbitId": "1",
      "values": {
        "distanceAu": 0.000381800775136746,
        "distanceMinAu": 0.00038157399962291,
        "distanceMaxAu": 0.000382027534025604,
        "vRelativeKms": 9.04061226311878,
        "vInfinityKms": 8.23257172787733,
        "absoluteMagnitudeH": 31.07,
        "diameterKm": null,
        "diameterSigmaKm": null
      },
      "timeSigma": "< 00:01",
      "candidateInputs": {
        "closeApproachFrequency": 0.2,
        "vInfKms": 8.23257172787733,
        "diameterConfidence": 0.32,
        "orbitAccessibility": 0.726,
        "sourceUncertainty": 0.001,
        "resourceClassConfidence": 0.05
      },
      "geometryScore": 14.73,
      "resourcePromotionAllowed": false,
      "evidenceState": "geometry-screen-only",
      "blockers": [
        "CAD close-approach geometry does not identify asteroid composition.",
        "SBDB object record, MPC observation bridge, and taxonomy/spectra/mission evidence are still required."
      ],
      "closeApproachCount": 1,
      "bestCloseApproachDate": "2026-May-22 22:11",
      "approachRows": [
        {
          "rowIndex": 8,
          "closeApproachDate": "2026-May-22 22:11",
          "distanceAu": 0.000381800775136746,
          "distanceMinAu": 0.00038157399962291,
          "distanceMaxAu": 0.000382027534025604,
          "vRelativeKms": 9.04061226311878,
          "vInfinityKms": 8.23257172787733,
          "timeSigma": "< 00:01"
        }
      ],
      "promotionGate": {
        "geometryScreenAllowed": true,
        "resourcePromotionAllowed": false,
        "state": "blocked-for-resource-composition",
        "blockers": [
          "CAD close-approach geometry does not identify asteroid composition.",
          "SBDB object record, MPC observation bridge, and taxonomy/spectra/mission evidence are still required."
        ],
        "allowedUse": "May be used to prioritize follow-up source intake and trajectory screening. May not be used as a resource composition claim."
      },
      "candidateHash": "sha256-c239b1bcd092750bc9e6a16707ffc3e73345d7a665a0f0cbdfbccc333e5ccc4e"
    },
    {
      "id": "cad-2026 FS5",
      "designation": "2026 FS5",
      "name": "2026 FS5",
      "rowIndex": 5,
      "sourceIds": [
        "cad-api"
      ],
      "sourceRecordType": "cad-close-approach-record",
      "closeApproachDate": "2026-Mar-22 11:40",
      "orbitId": "1",
      "values": {
        "distanceAu": 0.000308382401483998,
        "distanceMinAu": 0.000308080600714394,
        "distanceMaxAu": 0.000308684142058,
        "vRelativeKms": 10.791382031208,
        "vInfinityKms": 9.95859261736853,
        "absoluteMagnitudeH": 31.32,
        "diameterKm": null,
        "diameterSigmaKm": null
      },
      "timeSigma": "< 00:01",
      "candidateInputs": {
        "closeApproachFrequency": 0.2,
        "vInfKms": 9.95859261736853,
        "diameterConfidence": 0.32,
        "orbitAccessibility": 0.673,
        "sourceUncertainty": 0.002,
        "resourceClassConfidence": 0.05
      },
      "geometryScore": 6.53,
      "resourcePromotionAllowed": false,
      "evidenceState": "geometry-screen-only",
      "blockers": [
        "CAD close-approach geometry does not identify asteroid composition.",
        "SBDB object record, MPC observation bridge, and taxonomy/spectra/mission evidence are still required."
      ],
      "closeApproachCount": 1,
      "bestCloseApproachDate": "2026-Mar-22 11:40",
      "approachRows": [
        {
          "rowIndex": 5,
          "closeApproachDate": "2026-Mar-22 11:40",
          "distanceAu": 0.000308382401483998,
          "distanceMinAu": 0.000308080600714394,
          "distanceMaxAu": 0.000308684142058,
          "vRelativeKms": 10.791382031208,
          "vInfinityKms": 9.95859261736853,
          "timeSigma": "< 00:01"
        }
      ],
      "promotionGate": {
        "geometryScreenAllowed": true,
        "resourcePromotionAllowed": false,
        "state": "blocked-for-resource-composition",
        "blockers": [
          "CAD close-approach geometry does not identify asteroid composition.",
          "SBDB object record, MPC observation bridge, and taxonomy/spectra/mission evidence are still required."
        ],
        "allowedUse": "May be used to prioritize follow-up source intake and trajectory screening. May not be used as a resource composition claim."
      },
      "candidateHash": "sha256-8e2d541a2ee819b441141956c87b74ee2ad79c03d4f747d154588f973c66c3f4"
    },
    {
      "id": "cad-2026 ET3",
      "designation": "2026 ET3",
      "name": "2026 ET3",
      "rowIndex": 7,
      "sourceIds": [
        "cad-api"
      ],
      "sourceRecordType": "cad-close-approach-record",
      "closeApproachDate": "2026-Mar-15 04:01",
      "orbitId": "1",
      "values": {
        "distanceAu": 0.0003520371549018,
        "distanceMinAu": 0.000351523241049475,
        "distanceMaxAu": 0.000352551004040026,
        "vRelativeKms": 11.7529241924732,
        "vInfinityKms": 11.0902541784934,
        "absoluteMagnitudeH": 29.84,
        "diameterKm": null,
        "diameterSigmaKm": null
      },
      "timeSigma": "< 00:01",
      "candidateInputs": {
        "closeApproachFrequency": 0.2,
        "vInfKms": 11.0902541784934,
        "diameterConfidence": 0.32,
        "orbitAccessibility": 0.639,
        "sourceUncertainty": 0.003,
        "resourceClassConfidence": 0.05
      },
      "geometryScore": 1.17,
      "resourcePromotionAllowed": false,
      "evidenceState": "geometry-screen-only",
      "blockers": [
        "CAD close-approach geometry does not identify asteroid composition.",
        "SBDB object record, MPC observation bridge, and taxonomy/spectra/mission evidence are still required."
      ],
      "closeApproachCount": 1,
      "bestCloseApproachDate": "2026-Mar-15 04:01",
      "approachRows": [
        {
          "rowIndex": 7,
          "closeApproachDate": "2026-Mar-15 04:01",
          "distanceAu": 0.0003520371549018,
          "distanceMinAu": 0.000351523241049475,
          "distanceMaxAu": 0.000352551004040026,
          "vRelativeKms": 11.7529241924732,
          "vInfinityKms": 11.0902541784934,
          "timeSigma": "< 00:01"
        }
      ],
      "promotionGate": {
        "geometryScreenAllowed": true,
        "resourcePromotionAllowed": false,
        "state": "blocked-for-resource-composition",
        "blockers": [
          "CAD close-approach geometry does not identify asteroid composition.",
          "SBDB object record, MPC observation bridge, and taxonomy/spectra/mission evidence are still required."
        ],
        "allowedUse": "May be used to prioritize follow-up source intake and trajectory screening. May not be used as a resource composition claim."
      },
      "candidateHash": "sha256-95c6c43ac317ae7036e5b865031ad57212f2cb625b1045de9e8fcf85933c70d3"
    },
    {
      "id": "cad-2026 JN4",
      "designation": "2026 JN4",
      "name": "2026 JN4",
      "rowIndex": 0,
      "sourceIds": [
        "cad-api"
      ],
      "sourceRecordType": "cad-close-approach-record",
      "closeApproachDate": "2026-May-15 13:44",
      "orbitId": "3",
      "values": {
        "distanceAu": 0.0000135393094047249,
        "distanceMinAu": 0.00000375170579701919,
        "distanceMaxAu": 0.0000253077902814512,
        "vRelativeKms": 23.1929310794925,
        "vInfinityKms": 12.0133440581274,
        "absoluteMagnitudeH": 33.38,
        "diameterKm": null,
        "diameterSigmaKm": null
      },
      "timeSigma": "00:06",
      "candidateInputs": {
        "closeApproachFrequency": 0.2,
        "vInfKms": 12.0133440581274,
        "diameterConfidence": 0.32,
        "orbitAccessibility": 0.61,
        "sourceUncertainty": 1,
        "resourceClassConfidence": 0.05
      },
      "geometryScore": 0,
      "resourcePromotionAllowed": false,
      "evidenceState": "geometry-screen-only",
      "blockers": [
        "CAD close-approach geometry does not identify asteroid composition.",
        "SBDB object record, MPC observation bridge, and taxonomy/spectra/mission evidence are still required."
      ],
      "closeApproachCount": 1,
      "bestCloseApproachDate": "2026-May-15 13:44",
      "approachRows": [
        {
          "rowIndex": 0,
          "closeApproachDate": "2026-May-15 13:44",
          "distanceAu": 0.0000135393094047249,
          "distanceMinAu": 0.00000375170579701919,
          "distanceMaxAu": 0.0000253077902814512,
          "vRelativeKms": 23.1929310794925,
          "vInfinityKms": 12.0133440581274,
          "timeSigma": "00:06"
        }
      ],
      "promotionGate": {
        "geometryScreenAllowed": true,
        "resourcePromotionAllowed": false,
        "state": "blocked-for-resource-composition",
        "blockers": [
          "CAD close-approach geometry does not identify asteroid composition.",
          "SBDB object record, MPC observation bridge, and taxonomy/spectra/mission evidence are still required."
        ],
        "allowedUse": "May be used to prioritize follow-up source intake and trajectory screening. May not be used as a resource composition claim."
      },
      "candidateHash": "sha256-5d3f5d4f563380f497cb409a8a58662a36c48e82ae0991169dcf01974bb2462b"
    },
    {
      "id": "cad-2026 HZ4",
      "designation": "2026 HZ4",
      "name": "2026 HZ4",
      "rowIndex": 2,
      "sourceIds": [
        "cad-api"
      ],
      "sourceRecordType": "cad-close-approach-record",
      "closeApproachDate": "2026-Apr-24 12:13",
      "orbitId": "1",
      "values": {
        "distanceAu": 0.000198589377334507,
        "distanceMinAu": 0.000196459289039482,
        "distanceMaxAu": 0.000200712651675717,
        "vRelativeKms": 13.2661785245408,
        "vInfinityKms": 12.2130027273613,
        "absoluteMagnitudeH": 29.75,
        "diameterKm": null,
        "diameterSigmaKm": null
      },
      "timeSigma": "< 00:01",
      "candidateInputs": {
        "closeApproachFrequency": 0.2,
        "vInfKms": 12.2130027273613,
        "diameterConfidence": 0.32,
        "orbitAccessibility": 0.604,
        "sourceUncertainty": 0.021,
        "resourceClassConfidence": 0.05
      },
      "geometryScore": 0,
      "resourcePromotionAllowed": false,
      "evidenceState": "geometry-screen-only",
      "blockers": [
        "CAD close-approach geometry does not identify asteroid composition.",
        "SBDB object record, MPC observation bridge, and taxonomy/spectra/mission evidence are still required."
      ],
      "closeApproachCount": 1,
      "bestCloseApproachDate": "2026-Apr-24 12:13",
      "approachRows": [
        {
          "rowIndex": 2,
          "closeApproachDate": "2026-Apr-24 12:13",
          "distanceAu": 0.000198589377334507,
          "distanceMinAu": 0.000196459289039482,
          "distanceMaxAu": 0.000200712651675717,
          "vRelativeKms": 13.2661785245408,
          "vInfinityKms": 12.2130027273613,
          "timeSigma": "< 00:01"
        }
      ],
      "promotionGate": {
        "geometryScreenAllowed": true,
        "resourcePromotionAllowed": false,
        "state": "blocked-for-resource-composition",
        "blockers": [
          "CAD close-approach geometry does not identify asteroid composition.",
          "SBDB object record, MPC observation bridge, and taxonomy/spectra/mission evidence are still required."
        ],
        "allowedUse": "May be used to prioritize follow-up source intake and trajectory screening. May not be used as a resource composition claim."
      },
      "candidateHash": "sha256-0c9622e281041537b7740c53f7b860ac6e75d072a32be12603d7e746a931722f"
    },
    {
      "id": "cad-2026 JV3",
      "designation": "2026 JV3",
      "name": "2026 JV3",
      "rowIndex": 6,
      "sourceIds": [
        "cad-api"
      ],
      "sourceRecordType": "cad-close-approach-record",
      "closeApproachDate": "2026-May-14 22:59",
      "orbitId": "2",
      "values": {
        "distanceAu": 0.000335097959791211,
        "distanceMinAu": 0.000334863897147954,
        "distanceMaxAu": 0.000335332004167003,
        "vRelativeKms": 12.6898619540927,
        "vInfinityKms": 12.0469874783314,
        "absoluteMagnitudeH": 30.49,
        "diameterKm": null,
        "diameterSigmaKm": null
      },
      "timeSigma": "< 00:01",
      "candidateInputs": {
        "closeApproachFrequency": 0.2,
        "vInfKms": 12.0469874783314,
        "diameterConfidence": 0.32,
        "orbitAccessibility": 0.609,
        "sourceUncertainty": 0.001,
        "resourceClassConfidence": 0.05
      },
      "geometryScore": 0,
      "resourcePromotionAllowed": false,
      "evidenceState": "geometry-screen-only",
      "blockers": [
        "CAD close-approach geometry does not identify asteroid composition.",
        "SBDB object record, MPC observation bridge, and taxonomy/spectra/mission evidence are still required."
      ],
      "closeApproachCount": 1,
      "bestCloseApproachDate": "2026-May-14 22:59",
      "approachRows": [
        {
          "rowIndex": 6,
          "closeApproachDate": "2026-May-14 22:59",
          "distanceAu": 0.000335097959791211,
          "distanceMinAu": 0.000334863897147954,
          "distanceMaxAu": 0.000335332004167003,
          "vRelativeKms": 12.6898619540927,
          "vInfinityKms": 12.0469874783314,
          "timeSigma": "< 00:01"
        }
      ],
      "promotionGate": {
        "geometryScreenAllowed": true,
        "resourcePromotionAllowed": false,
        "state": "blocked-for-resource-composition",
        "blockers": [
          "CAD close-approach geometry does not identify asteroid composition.",
          "SBDB object record, MPC observation bridge, and taxonomy/spectra/mission evidence are still required."
        ],
        "allowedUse": "May be used to prioritize follow-up source intake and trajectory screening. May not be used as a resource composition claim."
      },
      "candidateHash": "sha256-ecf65363587dbbc32114d0d8092e8ca2744789de0a273a60c5272844ea329ebb"
    }
  ],
  "blockedClaims": [
    "No candidate in this ledger has taxonomy, spectra, or mission product evidence.",
    "No candidate in this ledger has been promoted as a feedstock or resource-class claim.",
    "Live JPL fetches must preserve TLS, query URL, capture timestamp, raw hash, normalized hash, units, and reviewer approval before promotion."
  ],
  "ledgerHash": "sha256-ee609d008f0470c727ad738d35e9787a186b9e6c3d1fc92f4e37b74e2e1b28cd",
  "byteLength": 21248
}
;
